import { Injectable, inject } from '@angular/core'
import { MatSnackBar } from '@angular/material/snack-bar'
import { SnackBarAlertComponent } from '../components/alert/snack-bar-alert.component'
import { AlertData, AlertPosition, alertPositions } from '../../shared/models/alert.model'

@Injectable()
export class AlertService {
  matSnackBar = inject(MatSnackBar)

  openAlert(data: AlertData, duration = 5000, position: AlertPosition = 'bottomCenter') {
    return this.matSnackBar.openFromComponent(SnackBarAlertComponent, {
      panelClass: ['restricted-product-alert'],
      duration,
      data,
      ...alertPositions[position],
    })
  }

  closeAlert() {
    this.matSnackBar.dismiss()
  }
}
